import * as React from 'react';
import { Card } from './card';
import { cn } from '../lib/utils';

export interface EnhancedCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'interactive' | 'glass' | 'gradient';
  hover?: boolean;
}

const EnhancedCard = React.forwardRef<HTMLDivElement, EnhancedCardProps>(
  ({ className, variant = 'default', hover = true, ...props }, ref) => {
    const variantStyles = {
      default: '',
      interactive: 'interactive-card cursor-pointer',
      glass: 'glass-effect',
      gradient: 'bg-gradient-card',
    };

    return (
      <Card
        ref={ref}
        className={cn(
          variantStyles[variant],
          hover && 'hover-lift',
          'animate-in',
          className,
        )}
        {...props}
      />
    );
  },
);
EnhancedCard.displayName = 'EnhancedCard';

export { EnhancedCard };
